var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9991 0C5.37193 0 0 5.37368 0 12.0009C0 18.6281 5.37193 24 11.9991 24C18.6263 24 24 18.6281 24 12.0009C24 5.37368 18.6263 0 11.9991 0ZM11.9991 20.5974C7.2513 20.5974 3.40087 16.7487 3.40087 12.0009C3.40087 7.25131 7.2513 3.40263 11.9991 3.40263C16.7469 3.40263 20.5956 7.25131 20.5956 12.0009C20.5956 16.7487 16.7469 20.5974 11.9991 20.5974Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelos);
export default __webpack_public_path__ + "static/media/telos.b946cd12d3185a7fd471943ef77fb79e.svg";
export { ForwardRef as ReactComponent };